
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import Table from '@/store/modules/Table'

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
	modules: {
		Table,
		ReservationsTable: Table,
		ReturningOrdersTable: Table,
		ReturningOrderProductsTable: Table,
		OrderProductListTable: Table,
		ReturningOrdersProductsTable: Table,
		ReturningOrderProductListTable: Table,
		OrdersProductsTable: Table,
		ReservationProductsTable: Table,
		ProductsTable: Table,
		OrderProductListTable: Table,
		SupplierOrdersTable: Table,
		SupplierOrderProductsTable: Table
	}
}
